import { Title } from '@patternfly/react-core';
import React from 'react';
import './AppHeader.scss';

interface AppHeaderProps {
  title: string;
}

const AppHeader: React.FC<AppHeaderProps> = ({ title }) => {
  return (
    <Title className="app-header" headingLevel="h1" size="3xl">
      {title}
    </Title>
  );
};

export default AppHeader;
